module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  上传厂商证书\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5525bed0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/certUpload.vue
// module id = 1043
// module chunks = 0